module.exports = __webpack_public_path__ + "6-9e260f71.png";